import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { Link, Redirect } from 'react-router-dom';
import Favicon from 'react-favicon';
import configs from 'configs';
import { loginUser } from './actions';
import { makeSelectLogin } from './selectors';
import reducer from './reducer';
import saga from './saga';
import { setAuthToken, setUsername, setUserRole } from '../../utils/auth';
import { APP_MAIN_LOGO } from '../App/constants';

export class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: APP_MAIN_LOGO,
    };
  }

  onHandleLogin = event => {
    event.preventDefault();

    const email = event.target.email.value;
    const password = event.target.password.value;
    const disconnectOthers = event.target.disconnectOthers ? event.target.disconnectOthers.checked : false;

    const data = {
      email,
      password,
      disconnectOthers,
    };

    this.props.login(data);
  };

  componentWillMount() {
    const query = this.props.location.search;
    if (query === '?rent365')
      this.setState({
        logo:
          'https://cdn1.carplanner.com/ideal/dealers/rent365/logo.png',
      });
  }

  render() {
    const { user } = this.props;
    const { logo } = this.state;
    if (localStorage.getItem('access_token')) {
      return <Redirect to="/" />;
    }
    if (user !== undefined && user.access_token !== undefined) {
      setAuthToken(user.access_token);
      setUsername(user.name);
      setUserRole(user.role);
      return <Redirect to="/" />;
    }

    const error = user.error && user.error !== '';
    let errorMessage;
    let errorCta = false;

    switch (user.message) {
      case 'Suspended':
        errorMessage = 'Questo account non risulta ancora attivo';
        break;
      case 'Sso':
        errorMessage = "Per accedere ti invitiamo a usare la piattaforma HPA";
        break;
      case 'Single Session Login':
        errorMessage =
          "Questo account ha già effettuato l'accesso su un altro dispositivo";
        errorCta = true;
        break;
      default:
        errorMessage = 'Credenziali di accesso errate';
        break;
    }

    return (
      <div className="all-wrapper menu-side with-pattern">
        <Favicon url={Object.values(configs.favicons)} animated={false} />
        <div className="auth-box-w wider">
          <div className="logo-w" style={{ padding: '10%' }}>
            <Link to="/login">
              <img
                alt="Logo"
                style={{ width: '160px' }}
                src={logo}
              />
            </Link>
          </div>

          <h4 className="auth-header">Area Riservata</h4>

          <form onSubmit={this.onHandleLogin}>
            <div
              className={
                !error ? 'form-group' : 'form-group has-error has-danger'
              }
            >
              <label htmlFor="email">Email</label>
              <input
                className="form-control"
                type="email"
                name="email"
                required
              />
              <div className="pre-icon os-icon os-icon-user-male-circle" />
            </div>
            <div
              className={
                !error ? 'form-group' : 'form-group has-error has-danger'
              }
            >
              <label htmlFor="password"> Password</label>
              <input
                className="form-control"
                type="password"
                name="password"
                required
              />
              <div className="pre-icon os-icon os-icon-fingerprint" />
            </div>

            {error && (
              <div className="help-block form-text text-danger form-control-feedback">
                {errorMessage}
              </div>
            )}
            {errorCta && <div className="d-block form-control-feedback">
              <label htmlFor="disconnect-others">
                <input
                  className="form-control"
                  type="checkbox"
                  name="disconnectOthers"
                  id="disconnect-others"
                /> Disconnetti il dispositivo collegato a questo account</label>
            </div>
            }

            <div className="buttons-w">
              <button className="btn btn-primary" type="submit">
                Accedi
              </button>
            </div>
            <div className="buttons-w text-center">
              <Link
                to="/account/password/forgot"
                title="Recupero Password"
                className="btn btn-default"
              >
                Hai dimenticato la password?
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    login: data => dispatch(loginUser(data)),
  };
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectLogin(),
});
const withReducer = injectReducer({ key: 'login', reducer });
const withSaga = injectSaga({ key: 'login', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(LoginPage);
